import Search from '../components/search/search.vue'
import Persona from '../components/search/persona.vue'
import SubscriberLookup from '../components/lookup/subscriber-lookup.vue'
export default [
  { path: '/', 
    name: 'default',
    component: Search,
  },
  { path: '/search', 
    name: 'search',
    component: Search,
  },
  { path: '/lookup', 
    name: 'lookup',
    component: SubscriberLookup,
  },
  { path: '/personas', 
    name: 'persona',
    component: Persona,
  },
]
